import { render, staticRenderFns } from "./SafetyObservationListing.vue?vue&type=template&id=563afefe&"
import script from "./SafetyObservationListing.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationListing.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservationListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports